import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";

export function checkToken(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const authService = inject(AuthService);
  const expiresIn = parseInt(authService.expiresIn()!);

  if(expiresIn !== null && ( expiresIn > 0 && expiresIn <= 60 ) ){
    authService.refreshToken();
  }

  return next(req);
}